import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as Set } from "assets/sidebar/enable/sets.svg";
import { ReactComponent as Category } from "assets/sidebar/enable/category.svg";
import { ReactComponent as Collection } from "assets/sidebar/enable/collection.svg";
import { ReactComponent as Archive } from "assets/sidebar/enable/archive.svg";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import { ReactComponent as EditIcon } from "assets/icons/CatalogueCard/edit.svg";
import { ReactComponent as TrashIcon } from "assets/icons/trash.svg";
import { IconButton, styled, Badge, Checkbox, Typography, Select, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SortContext from "context/SortContext";
import SortModal from "components/ui/SortModal";
import FilterModal from "components/ui/FilterModal/FilterModal";
import ArchiveRemoveModal from "components/ui/RemoveModal/RemoveModal";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import CreateBtn from "./CreateBtn";

import Button from "components/ui/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Tooltip from "components/ui/Tooltip";
import EditCatagoryBtn from "./EditCatagoryBtn";
import DropdownBtn from "features/set/components/DropdownBtn";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { ReactComponent as Setting } from "assets/sidebar/enable/setting.svg";
import { ReactComponent as Collapse } from "assets/icons/collapse.svg";
import { ReactComponent as Expand } from "assets/icons/expand.svg";
import CartPageModal from "components/ui/FilterModal/CartPageModal/CartPageModal";
import { transformDataForCreateOrderPage } from "utils/transformdata";
import { ReactComponent as Calendar } from "assets/icons/Calender.svg";
import DatePickerComp from "features/Setting/order/components/react-DatePicker/DatePickerComp";
import ClientsChildHeader from "components/ui/ClientsChildHeader";
import { useDispatch, useSelector } from "react-redux";
import { addMultipleToCart, clearCart, removeMultipleFromCart } from "store/cartSlice";
import { getIcon } from "utils/iconsConfig";
import { getLimits } from "features/Setting/Limits/api/limitsApis";
import { toast } from "react-toastify";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import { useQueryClient } from "@tanstack/react-query";

import StreamingIcon from "assets/icons/StreamingIcon/StreamingIcon.jsx";
import StreamingModal from "components/ui/StreamingModal/StreamingModal";
import apiClient from "lib/api-client";
import BulkQuoteModal from "components/ui/BulkQuoteModal/BulkQuoteModal";

const StyledButton = styled(Button)(({ theme, variant, disabled, fullwidth }) => ({
  width: fullwidth ? "100%" : "110px",
  fontFamily: "karla",
  fontWeight: 400,
  fontSize: "16.8px",
  lineHeight: "21.04px",
  height: "41px",
  borderRadius: "5px",
  color: "#FFF",
  border: `1px solid #fff`,
  textTransform: "none",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",

  "&.no-hover:hover": {
    backgroundColor: "transparent",
    color: "#FFF",
  },

  "&:hover": {
    backgroundColor: "#fff",
    color: "#000",
  },
}));

const CircularCheckbox = styled(Checkbox)(() => ({
  padding: "4px",
  border: "0px",
  marginRight: "15px",
  alignSelf: "center",
  width: "20px",
  height: "20px",
  borderRadius: "6px",
  border: "1.5px solid #FFFFFF",
  "& svg": {
    display: "none",
    fontSize: 22,
    borderRadius: "4px",
  },

  "&.Mui-checked": {
    backgroundColor: "#50C878",
    border: "1.5px solid #FFFFFF",
    "&:before": {
      content: '"\\2714"',
      color: "white",
      fontSize: "12px",
    },
    "& .MuiSvgIcon-root": {
      backgroundColor: "#FFFFFF",
      color: "#50C878",
      border: "1px solid #FFFFFF",
      borderRadius: "5px",
      padding: "0px",
    },
  },

  "&.Mui-focusVisible": {
    outline: "none",
    boxShadow: "none",
  },

  "& .MuiSvgIcon-root:not(.Mui-checked)": {
    backgroundColor: "transparent",
    borderRadius: "5px",
    display: "none",
  },
}));

const ViewButton = styled(Button)(({ active }) => ({
  width: "60px",
  height: "auto",
  minHeight: "unset",
  minWidth: "unset",
  borderRadius: "7px",
  padding: "8px 0",
  backgroundColor: active ? "#fff" : "transparent",
  color: active ? "#000" : "#fff",
  border: "none",
  boxShadow: "none",
  transition: "background 0.15s, color 0.15s",
  "&:hover": {
    backgroundColor: active ? "#fff" : "rgba(255,255,255,0.08)",
    boxShadow: "none",
  },
  "& svg": {
    width: "24px",
    height: "24px",
    display: "block",
  },
}));

function IconsChild({ location }) {
  const navigate = useNavigate();
  const location1 = useLocation();

  const { collectionName, id } = useParams();

  const newName = location1?.state?.newName;
  const pathname = location1?.pathname;
  const isSetDesingsPage = location.pathname.includes("/Sets/");
  const isClientsDesingsPage = location.pathname.includes("Clients");
  const isCatalogReportPage = location.pathname.includes("/Catalog-ReportNew");
  const queryClient = useQueryClient();

  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [isLiveStreamMode, setIsLiveStreamMode] = useState({
    open: false,
    title: "",
    btnTitle: "",
    isEditLiveStreamModal: false,
    removeModalMode: "",
  });
  const [streamingRemoveModal, setStreamingRemoveModal] = useState(false);
  const [cartPageModalOpen, setCartPageModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [meltingRequestOption, setMeltingRequestOption] = useState("create");
  const [isMeltingRequestMenuOpen, setIsMeltingRequestMenuOpen] = useState(false);
  const [isBulkMeltingModalOpen, setIsBulkMeltingModalOpen] = useState(false);
  const { sortOptions, isEdit, setIsEdit, isEditClick, setIsEditClick, isCollectionEdit, setIsCollectionEdit, search } = useContext(SortContext);
  const handleClose = () => setSortOpen(false);
  const permission = usePermissions();
  const state = location?.state;
  const editCatalogue = state && state?.edit ? state?.edit : false;
  const archiveCatalog = state && state?.archiveCatalog ? state?.archiveCatalog : false;
  const viewCatalogueProduct = state && state?.view ? state?.view : false;
  const name = state && state?.name ? state?.name : null;
  const backPath = state && state?.backPath ? state?.backPath : null;
  const aiBinnysSelectDesign = state?.isSelectDesign;
  const aiNewDesigns = state?.newDesigns;
  const { isFilter, isSetFilter, filterCount, isCollectionFilter, setIsCollectionFilter, isCatalogFilter ,setFilter} = useFilter();
  const {
    createBtn,
    removeIcon,
    setTrashModalOpen,
    isArchive,
    setIsArchive,
    isArchiveBtn,
    setShowCollectionTrashIcon,
    addDesignBtn,
    editCatagoryBtn,
    editCatagoryBtnOption,
    expanded,
    setExpanded,
    setCartData,
    // cartData,
    // allAdded,
    setAllAdded,
    catalogData,
    isCalendarOpen,
    setIsCalendarOpen,
    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    appliedStartDate,
    setAppliedStartDate,
    appliedEndDate,
    setAppliedEndDate,
    setCheckCatalogBeforeNavigate,
    showActivityLogo,
    setShowActivityLogo,
    setSearchPlaceHolder,
    creatBtnName,
    sectionCounts,
    isLiveStreaming,
    setIsLiveStreaming,
    activeCatalogView,
    setActiveCatalogView,
  } = useGlobalContext();

  const { setTimeSpentCatalogOpen } = useCatalogSettingContext();

  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cartData);

  //const isLiveStream = localStorage.getItem('isLiveStream_' + location?.pathname?.split("/")[1]) === "true";

  const allAdded = React.useMemo(() => {
    if (!catalogData?.length) return false;

    return catalogData.every((design) => cartData.some((item) => item.styleNumber === design.styleNumber));
  }, [catalogData, cartData]);

  const isArchiveCatalog = location?.state && location?.state?.archiveCatalog ? location?.state?.archiveCatalog : false;
  // const isLiveStreamActive = location?.state && location?.state?.isLiveStreamActive ? location?.state?.isLiveStreamActive : false;
  const hasViewStreamingAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Live Streaming"), "create");
  const collectionViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "view");
  const categoryViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view");

  // const hasSetArchiveAccess = hasAccessPage(findSpecificPage("Sets", permission), "arch
  const hasViewCatalogReport = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Catalog Report"), "view");
  // const hasSetEditAccess = hasAccessPage(findSpecificPage("Sets", permission), "edit");
  // const hasAccessEditCatalog = hasAccessPage(findSpecificPage("Catalog", permission), "edit");
  const hasSetArchiveAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "archive");
  const hasSetEditAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "edit");
  const hasSetDeleteAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "delete");

  const hasViewCatalogReports = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Reports"), "catalog_reports");
  const hasAccessEditCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "edit");
  const hasAccessArchiveCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "archive");
  const hasAccessAddCategory = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view");
  const hasAccessAddCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "edit");
  const hasViewStreamingEditAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Live Streaming"), "edit");

  const hasViewStreamingCancelAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Live Streaming"), "cancel");
  const hasViewCreateMeltingAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Miscellaneous Stock"), "create_melting_request");
  const hasAccessEditCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "edit");
  const hasAccessDeleteCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "delete");
  const canShowEdit = isCollectionEdit === "view" && hasAccessEditCollection;

  const hasStreamingClickAccess = isLiveStreaming ? hasViewStreamingCancelAccess || hasViewStreamingEditAccess : hasViewStreamingAccess;

  // ---------------------------------------------------------------  Calendar Logic ------------------------------------------------------------------------ \\

  const onChange = (dates) => {
    const [start, end] = dates;
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const handleClearDate = () => {
    setSelectedStartDate(new Date());
    setSelectedEndDate(null);
    setAppliedStartDate(new Date());
    setAppliedEndDate(null);
  };

  // Calendar Submit button
  const handleApply = () => {
    setAppliedStartDate(selectedStartDate);
    setAppliedEndDate(selectedEndDate);
    setIsCalendarOpen(false);
  };

  const handleSetEditClick = () => {
    setIsEdit("click");
    setIsEditClick(true);
    sessionStorage.removeItem("removedDesignsBySet");
    localStorage.removeItem("archivedDesigns");
    // sessionStorage.removeItem("updateProductsData");
    sessionStorage.removeItem("RemoveCollectionDesign");
  };

  const handlTimeSpentCatalog = () => {
    setTimeSpentCatalogOpen(true);
  };

  const handleCollectionEditClick = () => {
    setIsCollectionEdit("click");
    setShowCollectionTrashIcon(true);
    sessionStorage.removeItem("updateProductsData");
  };

  const handleCollectionUpdate = () => {
    //set styleids in global state and then save it in session storage
    let existData = JSON.parse(sessionStorage.getItem("collectionsProductsData"));
    sessionStorage.setItem("updateProductsData", JSON.stringify(existData));
    navigate("/Category", {
      state: {
        innerChnages: true,
        catalogueName: `Editing ${location?.state?.name[0]} Collection`,
        collectionUpdate: true,
        backPath: location?.pathname,
        backName: location?.state?.name,
        openCart: false,
      },
    });
  };

  const handleCardClick = (itemId) => {
    let catalogWithProduct = { itemId };
    let countLimit = itemId?.iconsData?.[0]?.count;
    sessionStorage.setItem("countLimit", JSON.stringify(countLimit ?? null));
    sessionStorage.setItem("catalogWithProduct", JSON.stringify(catalogWithProduct));
    sessionStorage.setItem("updateProductsData", JSON.stringify([]));
    let catalogNumberAndName = encodeURIComponent(`${itemId.number} (${itemId.subname})`);

    const state = {
      // name: [`${itemId.number} (${itemId.subname})`],
      name: [...location?.state?.name],
      edit: true,
      // subName: "Edit",
      catalogueName: `${itemId.subname}`,
      isActivity: false,
      catalogSearch: search !== "" ? search : "",
    };
    setIsArchive(false);

    setCheckCatalogBeforeNavigate(false);
    navigate(`/Catalog/${itemId.id}?catalogNumberAndName=${catalogNumberAndName}`, { state });
  };

  const handleCatalogEdit = async () => {
    const userData = localStorage.getItem("userData");
    const userDataParsed = JSON.parse(userData);
    //we should check this on "ADD Design Button"
    // let data = await getLimits(userDataParsed?._id);
    // let limit = data?.exists?.designAddLimit;

    // if (catalogData?.numberOfStyles >= limit) {
    //   return toast.error(`You cannot add as your limit is ${limit}`);
    // }
    const stored = JSON.parse(sessionStorage.getItem("catalogWithProduct") || "null");
    const item = stored?.itemId ?? stored;
    if (item?.id) {
      handleCardClick(item);
    } else {
      // fallback: use URL param id and location state (user navigated directly or sessionStorage is stale)
      const existingParam = new URLSearchParams(location1.search).get("catalogNumberAndName") || "";
      const nameArr = location1?.state?.name || [];
      const nameForParam = existingParam || nameArr[0] || "";
      // derive subname from "514 (Test Ctwa)" → "Test Ctwa", same logic as Header resolvedCatalogueName
      const rawCatalogueName = location1?.state?.catalogueName || "";
      const bracketMatch = nameForParam.match(/\(([^)]+)\)/);
      const derivedCatalogueName = rawCatalogueName || (bracketMatch?.[1]?.trim()) || nameForParam.replace(/^#?\d+\s*/, "").trim();
      const state = {
        name: nameArr.length ? nameArr : (nameForParam ? [nameForParam] : []),
        edit: true,
        catalogueName: derivedCatalogueName,
        isActivity: false,
        catalogSearch: search !== "" ? search : "",
      };
      navigate(`/Catalog/${id}?catalogNumberAndName=${encodeURIComponent(nameForParam)}`, { state });
    }
  };

  const handleAddAllToCart = () => {
    if (allAdded) {
      // REMOVE all catalog items
      dispatch(removeMultipleFromCart(catalogData.map((d) => d.styleNumber)));
    } else {
      // ADD all catalog items
      const newItems = catalogData.filter((d) => d?.styleNumber).map((d) => transformDataForCreateOrderPage(d));

      dispatch(addMultipleToCart({ newItems, location }));
    }
  };

  const handleCatalogReportClick = () => {
    let prevState = location.state;
    let state = {
      ...prevState,
      name: [`${prevState?.name[0]}`, `Catalog Report`],
      isCatalogReport: true,
    };

    navigate(`${id}/Catalog-ReportNew/${location?.search}`, { state });
  };

  const btnInfo = [
    {
      btnName: isArchive ? "UnArchive" : "Archive",
      bgColor: "#E77B7B",
      click: () => {
        setIsArchive(!isArchive);
        setArchiveModalOpen(false);
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setArchiveModalOpen(false),
    },
  ];

  const streamingBtnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => {
        setStreamingRemoveModal(false);
      },
    },
    {
      btnName: "Yes",
      bgColor: "#50C878",
      click: async () => {
        try {
          const catalogId = id || "";
          const response = await apiClient.post("/api/v1/catalog/liveStream/cancel", { catalogId });
          toast.success(response?.data?.message, {
            autoClose: 2000,
            hideProgressBar: false,
          });
          setStreamingRemoveModal(false);
          setIsLiveStreamMode({
            ...isLiveStreamMode,
            title: "",
            btnTitle: "",
            open: false,
            isEditLiveStreamModal: false,
          });
          setIsLiveStreaming(false);
          queryClient.invalidateQueries(["catalogData"]);
        } catch (error) {
          toast.error(error?.response?.data?.message, {
            autoClose: 2000,
            hideProgressBar: false,
          });
          setStreamingRemoveModal(false);
          setIsLiveStreamMode({
            ...isLiveStreamMode,
            title: "",
            btnTitle: "",
            open: false,
            isEditLiveStreamModal: false,
          });
        }
      },
    },
  ];

  const handleArchiveCatalog = () => {
    let state = { archiveCatalog: true, innerChnages: true, edit: true };
    setSearchPlaceHolder("Search By Catalog or Design Number");
    navigate("/Catalog", { state });
  };

  const handleCreateMeltingRequest = () => {
    navigate("/Stock", {
      state: {
        newName: "Create Melting Stock",
        innerChnages: true,
        backPath: location.pathname,
      },
    });
  };

  const handleMeltingRequestSelection = (event) => {
    const selectedOption = event.target.value;
    if (selectedOption === "bulk") {
      setIsBulkMeltingModalOpen(true);
    } else {
      handleCreateMeltingRequest();
    }
    setMeltingRequestOption("create");
    setIsMeltingRequestMenuOpen(false);
  };

  useEffect(() => {
    sessionStorage.setItem("AppliedDateFilter", JSON.stringify({ appliedStartDate, appliedEndDate }));
  }, [appliedStartDate, appliedEndDate]);

  useEffect(() => {
    return () => {
      if (state?.name?.length === 1 && !collectionName) {
        setIsCalendarOpen(false);
        setSelectedStartDate(new Date());
        setSelectedEndDate(null);
        setAppliedStartDate(new Date());
        setAppliedEndDate(null);
        sessionStorage.removeItem("AppliedDateFilter");
      }
    };
  }, [collectionName, location]);

  const handleStreamingClick = (isLiveStream) => {
    if (!isLiveStream) {
      setIsLiveStreamMode({
        ...isLiveStreamMode,
        title: "Create live Stream",
        btnTitle: "Create",
        open: true,
        isEditLiveStreamModal: false,
      });
      return;
    }
    setIsLiveStreamMode({
      ...isLiveStreamMode,
      title: "",
      btnTitle: "",
      open: true,
      isEditLiveStreamModal: true,
    });
    return;
  };

  const catalogViewOptions = ["mixView", "CategoryView", "setView"];

  if (!viewCatalogueProduct && !editCatalogue) {
    return (
      <>
        {isSetDesingsPage && isEdit === "view" && hasSetEditAccess && (collectionViewAccess || categoryViewAccess) && newName !== "Create Order" ? (
          <DropdownBtn location={{ ...location }} />
        ) : (
          createBtn && location?.state?.newName !== "Create Order" && !archiveCatalog && !(showActivityLogo && creatBtnName === "Add Design") && <CreateBtn location={location} />
        )}
        
        {/* {(isEdit === "view" || isCollectionEdit === "view") && ((isSetDesingsPage && hasSetDeleteAccess) || (!isSetDesingsPage && hasAccessEditCollection)) && newName !== "Create Order" && ( */}
        {((isEdit === "view" && hasSetDeleteAccess) || isCollectionEdit === "view") && newName !== "Create Order" && (
          <IconButton
            onClick={isCollectionEdit === "view" ? handleCollectionEditClick : handleSetEditClick}
            // onClick={isSetDesingsPage ? handleSetEditClick : handleCollectionEditClick}
            disableTouchRipple
            sx={{
              marginLeft: "10px",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            {isCollectionEdit === "view" ? hasAccessDeleteCollection && <TrashIcon /> : hasAccessEditCollection && <EditIcon />}
            {/* <EditIcon /> */}
          </IconButton>
        )}

        {editCatagoryBtn && <EditCatagoryBtn location={location} />}

        {pathname?.includes("/Catalog") && newName === "Create Order" && pathname !== "/Catalog" && (
          <CircularCheckbox disableFocusRipple disableRipple onChange={handleAddAllToCart} checked={allAdded} />
        )}

        {showActivityLogo && (
          <>

            <div className="child-header-create-btn">
              <div style={{ height: "auto", border: "1px solid #fff", borderRadius: "8.5px" }}>
                {catalogViewOptions?.map((item) => {
                  const isActive = activeCatalogView === item;
                  return (
                    <ViewButton
                      key={item}
                      active={isActive ? 1 : 0}
                      onClick={() => setActiveCatalogView(item)}
                      disableRipple
                      disableFocusRipple
                      disableElevation
                    >
                      {getIcon(item, isActive ? "active" : "")}
                    </ViewButton>
                  );
                })}
              </div>
            </div>

            {hasViewCatalogReports && (
              <div className="child-header-create-btn">
                <StyledButton className="no-hover" fullwidth onClick={() => handleCatalogReportClick()} disableRipple disableFocusRipple>
                  {getIcon("By Catalog")}
                  Catalog Reports
                </StyledButton>
              </div>
            )}

            {/* Add Design  btn on catalog page  */}
            {hasAccessEditCatalog && createBtn && <CreateBtn location={location} />}

            {hasViewStreamingAccess && (
              <div className="child-header-create-btn">
                <Tooltip title="Stream">
                  <IconButton disableRipple disableFocusRipple onClick={hasStreamingClickAccess ? () => handleStreamingClick(isLiveStreaming) : undefined}>
                    <StreamingIcon color={isLiveStreaming ? "#E77B7B" : "white"} width={"21px"} height={"17px"} />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {hasAccessEditCatalog && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IconButton className="no-hover" onClick={() => handleCatalogEdit()} disableRipple disableFocusRipple>
                  <TrashIcon />
                </IconButton>
              </div>
            )}
          </>
        )}

        {!removeIcon && isFilter && (
          <div className="child-header-sort">
            <Tooltip title="Filter">
              <IconButton onClick={() => setFilterModalOpen(true)} disableRipple disableFocusRipple>
                <Badge badgeContent={filterCount} color="success">
                  <Filter />
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
        )}
        {removeIcon && (
          <div className="child-header-sort">
            <Tooltip title="Trash">
              <IconButton onClick={() => setTrashModalOpen(true)}>
                <TrashIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}

        {isClientsDesingsPage && (
          <div className="child-header-sort">
            <ClientsChildHeader sectionCounts={sectionCounts} />
          </div>
        )}

        {/* {createBtn && <CreateBtn location={location} />} */}

        {location?.pathname === "/CartOrder" && (
          <div className="child-header-sort">
            <Tooltip title={expanded ? "Collapse" : "Expand"}>
              <IconButton disableRipple disableFocusRipple onClick={() => setExpanded((prev) => !prev)}>
                {expanded ? <Collapse /> : <Expand />}
              </IconButton>
            </Tooltip>
          </div>
        )}
        {location?.pathname === "/Stock" && !location?.state?.innerChnages && (
          <div className="child-header-create-btn">
            {hasViewCreateMeltingAccess && (
              <Select
                value={meltingRequestOption}
                onChange={handleMeltingRequestSelection}
                open={isMeltingRequestMenuOpen}
                onOpen={() => {}}
                onClose={() => setIsMeltingRequestMenuOpen(false)}
                displayEmpty
                renderValue={() => (
                  <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCreateMeltingRequest();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Create Melting Request
                    </span>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsMeltingRequestMenuOpen(true);
                      }}
                      sx={{ color: "inherit", p: 0, "&:hover": { backgroundColor: "transparent" } }}
                    >
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "20px",
                          mt: "1px",
                          transform: isMeltingRequestMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.2s ease",
                        }}
                      />
                    </IconButton>
                  </div>
                )}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PaperProps: {
                    sx: {
                      marginTop: "6px",
                      borderRadius: "5px",
                      backgroundColor: "#FFFFFF",
                      padding: "2px",
                      width: "270px",
                      maxWidth: "270px",
                      overflowX: "hidden",
                      "& .MuiMenuItem-root": {
                        fontFamily: "Karla, sans-serif",
                        fontSize: "18px",
                        fontWeight: 400,
                        color: "#000000",
                        borderRadius: "5px",
                        margin: "2px",
                        justifyContent: "center",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        "&:hover": {
                          backgroundColor: "#444444",
                          color: "#FFFFFF",
                        },
                      },
                    },
                  },
                }}
                sx={{
                  height: "41px",
                  width: "270px",//270
                  minWidth: "270px",//270
                  padding: "0 8px",
                  color: "#FFFFFF",
                  border: "1px solid #FFFFFF",
                  borderRadius: "5px",
                  fontFamily: "Karla, sans-serif",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: "22px",
                  backgroundColor: "transparent",
                  marginRight: "18px",
                  marginTop: "7px",
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-icon": {
                    display: "none",
                  },
                  "& .MuiSelect-select": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "0 8px !important",
                  },
                }}
              >
                <MenuItem value="bulk">Create Bulk Melting Request</MenuItem>
              </Select>
            )}
          </div>
        )}

        {isSetFilter && (
          <div className="child-header-sort">
            <Tooltip title="Filter">
              <IconButton
                onClick={() => {
                  if (location1?.state?.openCart) {
                    setCartPageModalOpen(true);
                  } else {
                    setFilterModalOpen(true);
                  }
                }}
                disableRipple
                disableFocusRipple
              >
                {location?.pathname === "/CartOrder" ? (
                  newName !== "Create Melting Stock" && !location1?.state?.isMeltingFlow ? (
                    <Setting />
                  ) : null
                ) : (
                  <Badge badgeContent={filterCount} color="success">
                    <Filter />
                  </Badge>
                )}

                {/* <Badge badgeContent={filterCount} color="success">
                  {location?.pathname === "/CartOrder" ? <Setting /> : <Filter />}
                </Badge> */}
              </IconButton>
            </Tooltip>
          </div>
        )}
        {/* Filter On Collection Page  */}
        {isCollectionFilter && (
          <div className="child-header-sort">
            <Tooltip title="Filter">
              <IconButton onClick={() => setFilterModalOpen(true)} disableRipple disableFocusRipple>
                <Badge badgeContent={filterCount} color="success">
                  <Filter />
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
        )}

        {/* {filterModalOpen && <FilterModal open={filterModalOpen} setOpen={setFilterModalOpen} />} */}
        <FilterModal open={filterModalOpen} setOpen={setFilterModalOpen} isCollection={location?.state?.collection ? true : false} />
        <StreamingModal completeObject={isLiveStreamMode} setCompleteObject={setIsLiveStreamMode} removeModal={streamingRemoveModal} setRemoveModal={setStreamingRemoveModal} />
        <RemoveModal open={streamingRemoveModal} setOpen={setStreamingRemoveModal} heading={"Are you sure you want to cancel live stream?"} btnInfo={streamingBtnInfo} />
        <BulkQuoteModal
          open={isBulkMeltingModalOpen}
          onClose={() => {
            dispatch(clearCart());
            setIsBulkMeltingModalOpen(false);
          }}
          headerText="Create Bulk Melting Request"
        />
        <CartPageModal openModal={cartPageModalOpen} handleClose={setCartPageModalOpen} headLabel={"Bulk Customization"} />

        {/* for set archive */}
        {isEdit === "archive" && hasSetArchiveAccess && (
          <IconButton
            onClick={handleSetEditClick}
            disableTouchRipple
            sx={{
              marginLeft: "10px",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <Archive />
          </IconButton>
        )}

        {/* end */}
        {/* Add Design  btn on subcollection page  */}
        {addDesignBtn && hasAccessAddCategory && hasAccessAddCollection && (
          <div className="child-header-sort" onClick={() => handleCollectionUpdate()}>
            <StyledButton>Add Design</StyledButton>
          </div>
        )}

        {isCatalogReportPage && (
          <div className="child-header-create-btn">
            <StyledButton fullwidth onClick={handlTimeSpentCatalog} disableRipple disableFocusRipple>
              Total Time Spent on Catalog
            </StyledButton>
          </div>
        )}

        {location?.pathname === "/Catalog" && !archiveCatalog && location?.state?.newName !== "Create Order" && hasAccessArchiveCatalog && (
          <div className="child-header-sort">
            <Tooltip title="Archive">
              <IconButton onClick={handleArchiveCatalog} disableRipple disableFocusRipple>
                <Archive />
              </IconButton>
            </Tooltip>
          </div>
        )}

        {/* Filter On Catalog Page  */}
        {isCatalogFilter && (
          <div className="child-header-sort">
            <Tooltip title="Filter">
              <IconButton onClick={() => setFilterModalOpen(true)} disableRipple disableFocusRipple>
                <Badge badgeContent={filterCount} color="success">
                  <Filter />
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
        )}

        {!removeIcon && sortOptions?.length > 0 && (
          <div className="child-header-sort">
            <Tooltip title="Sort By">
              <IconButton onClick={() => setSortOpen(true)} disableRipple disableFocusRipple>
                <Sort />
              </IconButton>
            </Tooltip>
          </div>
        )}

        {/* <ArchiveRemoveModal open={archiveModalOpen} setOpen={setArchiveModalOpen} heading="Do you want to Archive the Catalog?" btnInfo={btnInfo} /> */}

        {((aiBinnysSelectDesign && collectionName === "Binny's Select Designs") || (aiNewDesigns && collectionName === "New Designs")) && (state?.name?.length !== 0) && (
          <div className="child-header-sort">
            <Tooltip title="Date">
              <IconButton onClick={() => setIsCalendarOpen(true)} disableRipple disableFocusRipple>
                <Calendar />
              </IconButton>
            </Tooltip>
          </div>
        )}

        <DatePickerComp
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          open={isCalendarOpen}
          handleClear={handleClearDate}
          handleApply={handleApply}
          onChange={onChange}
          handleClose={() => setIsCalendarOpen(false)}
          useIn={"IconChild"}
          allowSundays={true}
          maxDate={new Date()}
        />

        <SortModal open={sortOpen} handleClose={handleClose} title="Sort By" list={sortOptions} />
      </>
    );
  } else if (editCatalogue) {
    return (
      <>
        {/* {removeIcon && (
          <div className="child-header-sort">
            <IconButton onClick={() => setTrashModalOpen(true)} disableRipple disableFocusRipple>
              <TrashIcon />
            </IconButton>
          </div>
        )} */}

        {isArchiveCatalog && sortOptions?.length > 0 && (
          <div className="child-header-sort">
            <Tooltip title="Sort By">
              <IconButton onClick={() => setSortOpen(true)} disableRipple disableFocusRipple>
                <Sort />
              </IconButton>
            </Tooltip>
          </div>
        )}
        <SortModal open={sortOpen} handleClose={handleClose} title="Sort By" list={sortOptions} />
      </>
    );
  } else {
    return null;
  }
}

export default IconsChild;
